import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import SeccionCurso from './SeccionCurso';
import { ListGroup } from 'react-bootstrap';

export function SortableItem(props) {

    const {seccionInfo = {}, editarSecciones, codigoSeccion, idx , leccionInfo = {}, isLeccionSortable = false} = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({id: props.id});
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
        {isLeccionSortable ? (
            <ListGroup>
                <ListGroup.Item key={idx}>
                {idx + 1}. {leccionInfo.nombre} -{" "}
                {leccionInfo.codigoLeccion}
                </ListGroup.Item>
            </ListGroup>
        ): (
            <SeccionCurso
             editarSecciones={editarSecciones}
             codigoSeccion={codigoSeccion}
             nombre={seccionInfo.nombre}
             idx={idx}
             />
        )}
    </div>
  );
}